import { arrToObj } from '../util';
import { FETCH_ALL_ADMINS, SET_ADMIN } from '../actions/actionTypes';

const adminReducer = (state = {}, action) => {
	Object.freeze(state);
	const { admins, admin, email, type } = action;
	switch (type) {
		case FETCH_ALL_ADMINS:
			return arrToObj(admins, null, 'email');
		case SET_ADMIN:
			return { ...state, [email]: admin };
		default:
			return state;
	}
};

export default adminReducer;
